module.exports = __webpack_public_path__ + "static/media/lydia-payne.18d16e5f.jpeg";